module.exports = __webpack_public_path__ + "static/media/galerija_2023 (19).c00d0b0b.png";